import { render, staticRenderFns } from "./EnviromentalLawClassSelector.vue?vue&type=template&id=27dd1e80"
import script from "./EnviromentalLawClassSelector.vue?vue&type=script&lang=js"
export * from "./EnviromentalLawClassSelector.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EnviromentalLawClassSelector.vue?vue&type=style&index=1&id=27dd1e80&prod&lang=css"
import style2 from "./EnviromentalLawClassSelector.vue?vue&type=style&index=2&id=27dd1e80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports